/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2RightArrowLong/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2RightArrowLong({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2RightArrowLong",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 8,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#52606D"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2RightArrowLong.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 8"
 style={{'--as-1-20EGhy': alignSelf,'--mt-2-20EGhy': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-20EGhy': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-20EGhy': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-20EGhy': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-20EGhy': opacity,'--w-10-20EGhy': typeof width === 'number' ? `${width}px` : width,'--h-11-20EGhy': typeof height === 'number' ? `${height}px` : height,'--f-12-20EGhy': fill,'--a-7-20EGhy': isAnimated ? animation : "none",'--sd-8-20EGhy': isAnimated ? strokeDashoffset : 0,'--sd-9-20EGhy': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2RightArrowLong.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M9.809.038a.5.5 0 01.545.108l3.5 3.5a.5.5 0 010 .708l-3.5 3.5A.5.5 0 019.5 7.5V5H1a1 1 0 110-2h8.5V.5a.5.5 0 01.309-.462z"
 style={{'--f-12-20EGhy': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}